const axios = require("axios");

export const axiosRequest = axios.create({
  baseURL: process.env.REACT_APP_SERVER_URI,
  timeout: 6000,
});

let respinosApp = sessionStorage.getItem("respinosApp");
if (respinosApp !== null) {
  respinosApp = JSON.parse(respinosApp);
  axiosRequest.defaults.headers[
    "Authorization"
  ] = `Bearer ${respinosApp.token}`;
}

export const getRequest = async (url, param) => {
  return new Promise(async (resolve, reject) => {
    try {
      url = param ? `${url}/?${param}` : url;
      const { data } = await axiosRequest.get(url);
      resolve(data);
    } catch (error) {
      error.message = error.response
        ? error.response.data.error
        : error.message;
      reject(error);
    }
  });
};

export const getDetailRequest = async (url, param) => {
  return new Promise(async (resolve, reject) => {
    try {
      if (param === undefined) reject("invalid param id");
      url = `${url}/${param}`;
      const { data } = await axiosRequest.get(url);
      resolve(data);
    } catch (error) {
      error.message = error.response
        ? error.response.data.error
        : error.message;
      reject(error);
    }
  });
};

export const postRequest = (url, body) => {
  return new Promise(async (resolve, reject) => {
    try {
      const { data } = await axiosRequest.post(`${url}`, body);
      resolve(data);
    } catch (error) {
      error.message = error.response
        ? error.response.data.error
        : error.message;
      reject(error);
    }
  });
};

export const patchRequest = (url, body) => {
  return new Promise(async (resolve, reject) => {
    try {
      const { data } = await axiosRequest.patch(`${url}`, body);
      resolve(data);
    } catch (error) {
      error.message = error.response
        ? error.response.data.error
        : error.message;
      reject(error);
    }
  });
};

export const patchMultipartRequest = (url, body) => {
  return new Promise(async (resolve, reject) => {
    try {
      const formData = new FormData();
      for (const name in body) {
        formData.append(name, body[name]);
      }
      const { data } = await axiosRequest.patch(url, formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      resolve(data);
    } catch (error) {
      error.message = error.response
        ? error.response.data.error
        : error.message;
      reject(error);
    }
  });
};

export const deleteRequest = async (url, body) => {
  return new Promise(async (resolve, reject) => {
    try {
      const { data } = await axiosRequest.delete(url, { data: body });
      resolve(data);
    } catch (error) {
      error.message = error.response
        ? error.response.data.error
        : error.message;
      reject(error);
    }
  });
};
